import { useLiveQuery } from "dexie-react-hooks";
import type { RecipeApiItem } from "@recipevault/shared";
import { db } from "../../sync/db.js";

interface UseRecipeResult {
  recipe: RecipeApiItem | null;
  status: "loading" | "ready" | "not-found";
}

// Dexie's `get` resolves to `undefined` when the row is absent, so we normalize
// that to `null` here. That lets the initial-loading sentinel (`undefined`) stay
// distinct from "loaded, but not found" (`null`).
export function useRecipe(id: string | undefined): UseRecipeResult {
  const r = useLiveQuery(
    async () => (id ? ((await db.recipes.get(id)) ?? null) : null),
    [id],
    undefined as RecipeApiItem | null | undefined,
  );

  if (!id) return { recipe: null, status: "not-found" };
  if (r === undefined) return { recipe: null, status: "loading" };
  if (r === null) return { recipe: null, status: "not-found" };
  return { recipe: r, status: "ready" };
}
